import { Base } from '../base-component';
import './image-related-image-stack.component.scss';

import * as $ from 'jquery';

export class ImageRelatedImageStack extends Base {

	constructor(element: Element){

		super(element);

	}

	containers: any;
	buttons: any;
	scrollTO: any;
	clickedTarget: any;

	init(){

		this.containers = Array.from(this.element.querySelectorAll('.image-related-image-stack-item__type-feature'));
		this.buttons = Array.from(this.element.querySelectorAll('.image-related-image-stack-item'));

	}

	bindEvents() {

		this.buttons.map((item) => item.addEventListener('click', (event) => {

			let element;
			let clickedTarget = event.target;
			element = clickedTarget.closest('.image-related-image-stack-item');
			let clickedIndex = element.getAttribute('data-index'); 

			this.hideActiveButtons();
			element.classList.add('active');

			this.hideContainers();
			this.containers.map((item) => {
				if(item.getAttribute('data-index') === clickedIndex) {
					item.classList.remove('d-none');
					if(document.querySelector('.header')) {
						if(document.querySelector('.header').classList.contains('header--sticky')) {
							$('html,body').animate({ 
								scrollTop: $(this.element).offset().top - 65
							}, 'slow');
						}else{
							$('html,body').animate({ 
								scrollTop: $(this.element).offset().top - 195
							}, 'slow');
						}
					}
				}
				
			});
			
		}));
	
	}

	hideActiveButtons() {
		this.buttons.map((item) => {
			item.classList.remove('active');
		});
	}

	hideContainers() {
		this.containers.map((item) => {
			item.classList.add('d-none');
		});
	}

}


// WEBPACK FOOTER //
// ./components/image-related-image-stack/image-related-image-stack.component.ts